function formatPrice(price)
{
	// console.log(price, price.toFixed(2));
	return price.toFixed(2);
}